const ButtonLink = (props) => {
  return (
    <button
      type="button"
      style={{ width: 80 }}
      className={props.classes}
      onClick={props.onClickLink}
    >
      {props.content}
    </button>
  );
};

export default ButtonLink;
